export type PasswordRuleCheck = {
  id: string;
  label: string;
  met: boolean;
};

const SPECIAL_CHAR_REGEX = /[^A-Za-z0-9]/;

export function getPasswordRuleChecks(password: string): PasswordRuleCheck[] {
  return [
    {
      id: "length",
      label: "A senha precisa conter pelo menos 6 caracteres.",
      met: password.length >= 6,
    },
    {
      id: "uppercase",
      label: "A senha deve conter pelo menos 1 letra(s) maiúscula(s).",
      met: /[A-Z]/.test(password),
    },
    {
      id: "lowercase",
      label: "A senha deve conter pelo menos 1 letra(s) minúscula(s).",
      met: /[a-z]/.test(password),
    },
    {
      id: "number",
      label: "A senha deve conter pelo menos 1 número(s).",
      met: /[0-9]/.test(password),
    },
    {
      id: "special",
      label: "A senha deve conter pelo menos 1 caracter(es) especial(is).",
      met: SPECIAL_CHAR_REGEX.test(password),
    },
  ];
}

export function isPasswordValid(password: string): boolean {
  return getPasswordRuleChecks(password).every((rule) => rule.met);
}

export function getPasswordConfirmationCheck(
  password: string,
  confirmation: string,
): PasswordRuleCheck {
  return {
    id: "match",
    label: "A senha nova e a confirmação precisam ser iguais.",
    met: password.length > 0 && password === confirmation,
  };
}
